import React, { memo } from "react";

import { ShowcaseCard } from "ui/components/Showcase";

/** Slajd "Ponude, ugovori i računi": ponuda sa statusima, ugovor s potpisom i obavijest o računu. */
const DocumentsSlide: React.FC = () => {
  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-0 w-[17rem]" delay={0}>
        <div className="p-5">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Ponuda</div>
              <div className="text-sm font-bold text-slate-800">PON-2026-0042</div>
            </div>
            <span className="px-2 py-0.5 rounded-full bg-amber-50 text-[0.65rem] font-semibold text-amber-600">
              Prihvaćeno
            </span>
          </div>

          <div className="mt-4 flex items-center gap-3">
            <span className="flex items-center justify-center w-9 h-9 rounded-full bg-blue-100 text-xs font-bold text-blue-700">
              MH
            </span>
            <div>
              <div className="text-xs font-semibold text-slate-700">Marko Horvat</div>
              <div className="text-[0.65rem] text-slate-400">marko.horvat@orytron.com</div>
            </div>
          </div>

          <div className="mt-4 flex items-center gap-3 rounded-md bg-slate-50 p-2">
            <div className="flex items-center justify-center w-16 h-10 rounded-sm bg-gradient-to-br from-amber-200 to-amber-300 overflow-hidden">
              <img src="/media/images/vehicles/vehicle-3.png" alt="" className="w-16" />
            </div>
            <div>
              <div className="text-[0.7rem] font-semibold text-slate-700">Kia Sorento</div>
              <div className="text-[0.65rem] text-slate-400">ZG 1234 AB</div>
            </div>
          </div>

          <div className="mt-4 flex items-end justify-between border-t border-slate-100 pt-3">
            <span className="text-[0.7rem] text-slate-400">Ukupno</span>
            <span className="text-xl font-bold text-slate-800">12.450,00 €</span>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="h-2 rounded-t-lg bg-gradient-to-r from-blue-500 to-sky-400" />
        <div className="p-5">
          <div className="text-xs font-bold text-slate-800">Kupoprodajni ugovor</div>
          <div className="text-[0.65rem] text-slate-400">UG-2026-0017</div>
          <div className="mt-3 space-y-1.5">
            <div className="h-1.5 w-full rounded-full bg-slate-100" />
            <div className="h-1.5 w-5/6 rounded-full bg-slate-100" />
            <div className="h-1.5 w-4/6 rounded-full bg-slate-100" />
          </div>
          <svg
            className="mt-4 w-24 h-7"
            viewBox="0 0 80 24"
            fill="none"
            stroke="#1D4ED8"
            strokeWidth="1.8"
            strokeLinecap="round"
            aria-hidden="true"
          >
            <path d="M2 18c6-10 10-12 12-6s-2 8 2 4 8-12 12-8-4 10 2 8 10-10 14-8 2 8 8 6 12-6 22-6" />
          </svg>
          <div className="flex items-center justify-between border-t border-slate-100 pt-2 text-[0.65rem] text-slate-400">
            <span>Potpisano</span>
            <span className="font-semibold text-emerald-600">23. 9. 2026.</span>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <div className="flex items-center gap-3 px-4 py-3.5">
          <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-emerald-100 flex-shrink-0">
            <svg
              className="w-4 h-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#059669"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M5 12.5l4.5 4.5L19 7.5" />
            </svg>
          </span>
          <div>
            <div className="text-[0.7rem] font-bold text-slate-800">Račun je fiskaliziran</div>
            <div className="text-[0.65rem] text-slate-400">RAČ-2026-0118 · 12.450,00 €</div>
          </div>
        </div>
      </ShowcaseCard>
    </>
  );
};

export default memo(DocumentsSlide);
